(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-entries"] && !Shopify.designMode) return;
  try {
    /* Updates the product-page entries badge when the price or quantity changes.
   Collection cards are printed by Liquid and are left alone. */
(function () {
  function parsePrice(text) {
    var raw = String(text || '').replace(/[^0-9.,-]/g, '');
    if (!raw) return 0;
    var lastComma = raw.lastIndexOf(',');
    var lastDot = raw.lastIndexOf('.');
    if (lastComma > lastDot) {
      var after = raw.slice(lastComma + 1);
      if (after.length === 3 && lastDot === -1) raw = raw.replace(/,/g, '');
      else raw = raw.replace(/\./g, '').replace(',', '.');
    } else {
      raw = raw.replace(/,/g, '');
    }
    var amount = parseFloat(raw);
    return isNaN(amount) ? 0 : amount;
  }

  function priceRoot(wrap) {
    return wrap.closest('.th-pdp-details, .product-single, .product-single__meta') || document;
  }

  function visiblePrice(root) {
    var el = root.querySelector('[data-product-price]')
      || root.querySelector('.product-single__price:not(.product-single__price--compare)');
    return el ? el.textContent.trim() : '';
  }

  function currentQty() {
    var input = document.querySelector('[data-product-quantity], input[name="quantity"]');
    var qty = parseInt(input && input.value, 10);
    return qty > 0 ? qty : 1;
  }

  function formatEntries(amount) {
    var whole = Math.floor(Math.abs(amount));
    return whole.toLocaleString('en-US');
  }

  function updateWrap(wrap) {
    var badge = wrap.querySelector('.ss-entries-badge');
    if (!badge) return;
    var mult = parseFloat(badge.dataset.mult) || 1;
    var bonus = parseInt(badge.dataset.bonus, 10) || 0;
    var qty = currentQty();
    var base = parseFloat(badge.dataset.base) || 0;
    if (wrap.dataset.priceOverride !== 'true') {
      var shown = visiblePrice(priceRoot(wrap));
      if (shown) base = parsePrice(shown);
    }
    var value = badge.querySelector('.ss-entries-value');
    if (value) value.textContent = formatEntries(base * mult * qty);
    var bonusEl = badge.querySelector('.ss-entries-bonus');
    if (bonusEl) bonusEl.textContent = formatEntries(bonus * qty);
  }

  function updateAll() {
    document.querySelectorAll('.ss-entries-wrap-price').forEach(updateWrap);
  }

  function openPortal() {
    var portal = document.getElementById('ss-info-portal');
    if (!portal) return;
    if (portal.parentElement !== document.body) document.body.appendChild(portal);
    portal.setAttribute('open', '');
    portal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ss-modal-open');
    document.body.classList.add('ss-modal-open');
    var dialog = portal.querySelector('.ss-info-portal__dialog');
    if (dialog) dialog.focus();
  }

  function closePortal() {
    var portal = document.getElementById('ss-info-portal');
    if (!portal) return;
    portal.removeAttribute('open');
    portal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ss-modal-open');
    document.body.classList.remove('ss-modal-open');
  }

  function boot() {
    if (!document.querySelector('.ss-entries-wrap-price')) return;
    updateAll();
    document.addEventListener('input', function (event) {
      if (event.target.matches('[data-product-quantity], input[name="quantity"]')) updateAll();
    });
    document.addEventListener('change', function (event) {
      if (event.target.matches('[data-product-quantity], input[name="quantity"]')) updateAll();
    });
    document.addEventListener('click', function (event) {
      if (event.target.closest('.ss-info-trigger')) {
        event.preventDefault();
        openPortal();
        return;
      }
      if (event.target.closest('[data-ss-close]')) {
        event.preventDefault();
        closePortal();
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePortal();
    });
    var watched = document.querySelector('.th-pdp-details, .product-single__meta, .product-single');
    if (!watched) return;
    var lastPrice = visiblePrice(watched);
    var observer = new MutationObserver(function () {
      var nextPrice = visiblePrice(watched);
      if (nextPrice && nextPrice !== lastPrice) {
        lastPrice = nextPrice;
        updateAll();
      }
    });
    observer.observe(watched, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
  } catch(e) { console.error(e); }
})();

})();
